import { useAuthentication } from '@ecosystem/newron-client-lib';
import React, { useEffect, useMemo, useReducer, useState } from 'react';

import { UpsellName, UpsellStatus } from '../../common';
import { useUpsellMessage } from '../../hooks/useUpsellMessage';
import { postUpsellAnalytics } from '../../services/Market.service';
import { UpsellContext, initialState, reducer } from '../../state';
import { Notification } from '../notification';
import { TargetedUpsellMessage } from '../targeted-upsell-message/TargetedUpsellMessage';
import { OpenMarketOptions } from '../upsell-feedback/UpsellFeedback';

export interface UpsellMessageType {
  upsellMessage: string;
  countryCode: string;
  itemGroupCode: string;
  dataPeriod: number;
  dataPeriodDisplay: string;
  condition1: boolean;
  condition2: boolean;
}

export type UpsellFeedbackProps = {
  openMarketsOptions: OpenMarketOptions[];
  cells: string[];
};

export const TargetedUpsell = ({ cells, openMarketsOptions }: UpsellFeedbackProps): JSX.Element => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const contextValue = useMemo(() => ({ state, dispatch }), [state]);
  const [showUpsellModal, setShowUpsellModal] = useState(true);

  const { upsellMessageForSlide } = useUpsellMessage(cells, openMarketsOptions);

  const { user, getAccessToken } = useAuthentication();

  useEffect(() => {
    (async () => {
      if (upsellMessageForSlide) {
        const analyticsData = {
          cell: upsellMessageForSlide?.countryCode + '-' + upsellMessageForSlide?.itemGroupCode,
          dataPeriod: upsellMessageForSlide?.dataPeriodDisplay,
          userId: user?.userId,
          upsellName: UpsellName.MONTHLY_INSIGHTS,
          upsellStatus: UpsellStatus.UPSELL_SHOWN,
        };

        const token = await getAccessToken();

        await postUpsellAnalytics(token, analyticsData);
      }
    })();
  }, [getAccessToken, upsellMessageForSlide, user?.userId]);

  const onCloseHandler = (value: boolean) => {
    setShowUpsellModal(value);
  };

  return (
    <div data-test-id="targeted-upsell-message">
      <UpsellContext.Provider value={contextValue}>
        <TargetedUpsellMessage
          setShowUpsellModal={setShowUpsellModal}
          showUpsellModal={showUpsellModal}
          upsellMessageForSlide={upsellMessageForSlide}
          onClose={() => onCloseHandler(false)}
        />
        <Notification />
      </UpsellContext.Provider>
    </div>
  );
};
